<template>
  <div class="_title" :class="{'small': small}">
    <span class="jpn">{{jpn}}</span>
  </div>
</template>

<script>
export default {
  props: {
    jpn: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  text-align: center;
  color: $gray2;
  font-size: 24px;
  font-weight: bold;
  border-bottom: 1px solid $gray2;
  padding: 10px 0;
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    text-align: center;
    margin-bottom: 20px;
    .background {
      font-size: 50px;
    }
    .eng {
      margin-top: -60px;
    }
    &.small {
      .background {
        font-size: 50px;
      }
    }
  }
}
</style>
